import type { SVGProps } from 'react';

const SvgCastOnBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M6.80078 15H11.8008M2.80078 5.875C2.80078 5.39175 3.20372 5 3.70078 5H15.3008C15.7979 5 16.2008 5.39175 16.2008 5.875V9.64583C16.2008 9.64583 20.8008 6 20.8008 8.1875C20.8008 10.375 20.8008 14.5 20.8008 16.25C20.8008 18 16.2008 14.7917 16.2008 14.7917V18.125C16.2008 18.6083 15.7979 19 15.3008 19H3.70078C3.20372 19 2.80078 18.6083 2.80078 18.125V5.875Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle cx={21.8008} cy={2} r={2} fill='#FF5A5A' />
  </svg>
);
export default SvgCastOnBd;
